<template>
	<div class="view-index-v">
		<div class="inf-wrapper">
			<div class="auto-height">
				<div class="content calc-line" v-html="content"></div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		getAction
	} from '@/api/index';
	export default {
		name: 'IndexV',
		data() {
			return {
				url: {
					otherSetting: '/officialWebsite/c-api/setting/other'
				},
				data: {}
			}
		},
		computed: {
			content() {
				return '电话：<a href="tel:'+this.phoneNumber+'">' + this.data.phoneNumber 
					+ '</a><br />&emsp; &emsp; （' + this.data.businessHours + '）<br /><br/>' +
					'邮箱：' + this.data.email
			},
			phoneNumber() {
				return this.data.phoneNumber ? 
					this.data.phoneNumber.replace(/[^0-9]/g, '').replace(/\D/g,'').replace(/\b(0+)/gi,"") : ''
			}
		},
		mounted() {
			this.loadData();
		},
		methods: {
			async loadData() {
				const res = await getAction(this.url.otherSetting);
				if (res.success) {
					this.data = res.result;
					this.calcContentHeight();
				}
			},
			calcContentHeight() {
				this.$nextTick(() => {
					let doms = document.getElementsByClassName('auto-height');
					for (let i = 0; i < doms.length; i++) {
						doms[i].style.height =
							(doms[i].getElementsByClassName('calc-line')[0].getBoundingClientRect().height) + 'px';
					}
				});
			}
		}
	}
</script>
<style scoped lang="less">
	.view-index-v {
		width: 100%;
		position: relative;

		.inf-wrapper {
			width: 100%;
			padding: 0 calc(52px * var(--scale-rate)) calc(70px * var(--scale-rate));

			.content {
				width: calc(100% / var(--scale-rate));
				font-size: 30px;
				letter-spacing: 12px;
				font-weight: 300;
				color: rgb(35, 35, 35);
				transform: scale(var(--scale-rate));
				transform-origin: left top;
				padding-top: 40px;
				padding-left: 27px;
			}
		}
	}
</style>